import { Component } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-user-import-orders-created',
  templateUrl: './user-import-orders-created.component.html',
  styleUrls: ['./user-import-orders-created.component.css'],
  providers: [ConfirmationService]
})
export class UserImportOrdersCreatedComponent {
}
